import script from "./QuestionTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionTooltip.vue?vue&type=script&setup=true&lang=js"

import "./QuestionTooltip.vue?vue&type=style&index=0&id=0100c64a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0100c64a"]])

export default __exports__